import React from 'react';
import { Link } from 'react-router-dom';

const variants = {
  primary:
    'tw-bg-accent-500 hover:tw-bg-accent-600 tw-text-white tw-font-semibold tw-shadow-sm hover:tw-shadow-md tw-transition-all tw-duration-200',
  secondary:
    'tw-bg-white tw-text-primary-600 tw-border tw-border-primary-200 hover:tw-bg-primary-50 hover:tw-border-primary-300 tw-font-semibold tw-transition-all tw-duration-200',
  ghost:
    'tw-bg-transparent tw-text-gray-600 hover:tw-text-gray-900 hover:tw-bg-gray-100 tw-font-medium tw-transition-all tw-duration-200',
  outline:
    'tw-bg-transparent tw-text-primary-600 tw-border tw-border-primary-500 hover:tw-bg-primary-500 hover:tw-text-white tw-font-semibold tw-transition-all tw-duration-200',
  white:
    'tw-bg-white tw-text-primary-700 hover:tw-bg-gray-50 tw-font-semibold tw-shadow-sm tw-transition-all tw-duration-200',
};

const sizes = {
  sm: 'tw-px-3 tw-py-1.5 tw-text-sm tw-rounded-md',
  md: 'tw-px-5 tw-py-2.5 tw-text-sm tw-rounded-lg',
  lg: 'tw-px-8 tw-py-3.5 tw-text-lg tw-rounded-lg',
};

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  as,
  to,
  href,
  className = '',
  disabled = false,
  type = 'button',
  ...props
}) => {
  const classes = `tw-inline-flex tw-items-center tw-justify-center tw-no-underline tw-cursor-pointer ${variants[variant] || variants.primary} ${sizes[size] || sizes.md} ${disabled ? 'tw-opacity-50 tw-cursor-not-allowed' : ''} ${className}`.trim();

  if (as === Link || to) {
    return (
      <Link to={to} className={classes} {...props}>
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={classes} {...props}>
        {children}
      </a>
    );
  }

  return (
    <button type={type} className={classes} disabled={disabled} {...props}>
      {children}
    </button>
  );
};

export default Button;
